import React, { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import BASE_URL from "../../../baseUrl";
import ListingFilter from "../pricing/ListingFilter";
import Categories from "../homefour/Categories";
import ListingCard from "../../shared/ListingCard";

const Content = () => {
  const [state, setState] = useState([]);
  const [filter, setFilter] = useState([]);
  const [screen2, setScreen2] = useState(null);
  const [SearhingData, setSearhingData] = useState();
  const [Data, setdata] = useState([])
  const { t } = useTranslation()

  const navigate = useNavigate();

  const getData2 = async () => {
    const response = await fetch(
      `${BASE_URL}/submitlisting/submitRent`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          mode: "no-cors",
        },
      }
    );
    const data = await response.json();
    setState(data?.result);
  };

  useEffect(() => {
    getData2();
  }, []);

  useEffect(() => {
    if (SearhingData) {
      setdata(SearhingData)
    }

  }, [SearhingData]);


  const getData = async (filterobj) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/submitlisting/search`,
        {
          city: filterobj.city,
          type: filterobj.type ? filterobj.type : "Any Property",
          priceRange: filterobj.priceRange,
          country: filterobj.country,
          status: filterobj.status === "Any Status" ? "" : filterobj.status,
          states: filterobj.states,
        }

      );
      if (response) {
        setState(response.data.result)
      }
      else {
      }

    } catch (error) {
    }
  };


  const filterData = (data) => {
  }



  const acessChat = () => {
    return;
  };





  return (
    <div>
      <div className="container flex justify-center flex-col">
        <div className="shadow-sm mt-3 rounded">
          <ListingFilter getData={filterData} />
        </div>
        <Categories type="Rent" />
      </div>
      <div className="flex justify-center container">
        <div className="my-8" >
          {screen2 ? (
            filter.length === 0 ? (
              <div className="flex justify-center">
                <div className="md:w-9/12 lg:w-4/6  border p-10 border-gray-500 rounded-lg flex justify-between items-center">
                  <div className="w-32 pr-12">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/exclaimationMark.png`}
                      width={"100%"}
                      alt="NotFound"
                    />
                  </div>
                  <div className="w-10/12">
                    <h2 className="mb-4 text-gray italic">{`Property Not Found `}</h2>
                    <p className="text-gray-200">
                      Sorry, the specific type of property you are searching for
                      is currently not available on our website. Please check
                      back later or contact us for further assistance
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="my-8 text-center text-2xl font-semibold">
                  Data After Filter
                </div>
                <div className="row">
                  {filter?.map((res, index) => {
                    return (
                      <div key={index} className="col-lg-4 col-md-6 mb-4">
                        <ListingCard listing={res} t={t} />
                      </div>
                    );
                  })}
                </div>
              </div>
            )
          ) : state?.length === 0 ? (
            <div className="flex justify-center">
              <div className="md:w-9/12 lg:w-4/6 my-4  border p-10 border-gray-500 rounded-lg flex justify-between items-center">
                <div className="w-32 pr-12">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/exclaimationMark.png`}
                    width={"100%"}
                    alt="NotFound"
                  />
                </div>
                <div className="w-10/12">
                  <h2 className="mb-4 text-gray italic"> {t("propertyNotFoundHeading")}</h2>
                  <p className="text-gray-200">
                    {t("propertyNotFoundDescription")}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              {state.map((res, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <ListingCard listing={res} t={t} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default Content;
